
import { css } from 'lit';
export default css`
:host {
  position: absolute;
  width: 100%;
  display: block;
  z-index: 300
}

.search__panel {
  position: absolute
}

.search__panel {
  width: 100%
}

.search__panel {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity))
}

@media (min-width: 1024px) {

  .search__panel {
    z-index: 9999
  }
}

.search__panel {
    padding: 35px 21px 35px 21px;
    top: 80px;
    border-radius: 0.75rem
  }

.search__panel {
  --tw-shadow: 0 0 36px 0px rgba(0,0,0,0.16);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}

.search__panel--container {
  margin: auto
}

.search__panel--container {
  max-width: 64rem
}

@media (min-width: 1024px) {

.search__panel--main-menu-search {
        top: 46px;
        width: 200%;
        left: -50%
    }
        @media (min-width: 1664px) {

.search__panel--main-menu-search {
          width: 1440px;
          left: -371px
    }
        }
      }

.search__panel--hidden {
  display: none
}

.search__panel__item-icon {
  height: 1rem
}

.search__panel__item-icon {
  width: 1rem
}

@media (min-width: 1024px) {

.search__panel {
      padding: 50px 38px 38px 38px
  }
    }

.search__panel--suggested-only {
  z-index: 10
}

.search__panel--suggested-only {
      top: 0;
      left: -1rem;
      width: calc(100% + 3rem);
      padding: 28px 38px 28px;
      border-radius: 0;
      min-height: 165px;
    }

@media (min-width: 768px) {

.search__panel--suggested-only {
        padding: 30px 38px 28px 38px;
        min-height: initial;
        top: 80px;
        width: 100%;
        left: initial;
        border-radius: 0.75rem
    }
      }

.search__panel--overlay-mobile {
  position: absolute
}

.search__panel--overlay-mobile {
  top: 0px
}

.search__panel--overlay-mobile {
  bottom: 0px
}

.search__panel--overlay-mobile {
  left: 0px
}

.search__panel--overlay-mobile {
  right: 0px
}

.search__panel--overlay-mobile {
  --tw-bg-opacity: 1;
  background-color: rgba(53, 25, 108, var(--tw-bg-opacity))
}

.search__panel--overlay-mobile {
      left: -1rem;
      width: calc(100% + 2rem);
      z-index: -1;
      min-height: 9999px;
    }

@media (min-width: 768px) {

.search__panel--overlay-mobile {
        display: none
    }
      }

.search__panel--hidden {
  display: none
}

.search__panel__item-icon {
  height: 1rem
}

.search__panel__item-icon {
  width: 1rem
}

@media (min-width: 1024px) {

.search__panel {
      padding: 50px 38px 38px 38px;
      min-height: initial
  }
    }

.search__results-grid {
  border-bottom-width: 1px
}

.search__results-grid {
  border-style: solid
}

.search__results-grid {
  --tw-border-opacity: 1;
  border-color: rgba(216, 216, 216, var(--tw-border-opacity))
}

.search__results-grid {
    margin-bottom: 36px;
    padding-bottom: 38px;
  }

@media (min-width: 1024px) {

.search__results-grid {
      padding-bottom: 32px;
      margin-bottom: 32px
  }
    }

.search__results-offleft {
    position: absolute;
    left: -9999px;
  }

.search__panel__item {
  display: block
}

.search__panel__item {
  font-weight: 400
}

.search__panel__item {
  --tw-text-opacity: 1;
  color: rgba(35, 35, 35, var(--tw-text-opacity))
}

.search__panel__item {
    margin: 0.25rem 0;
    font-size: 16px;
    line-height: 27px;
  }

.search__panel__item--highlight {
  font-weight: 700
}

.search__panel__item--highlight {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity))
}

.search__panel__item:hover {
  text-decoration: underline
}

.search__panel__item-icon {
  margin-left: 1rem
}

.search__panel__item-icon {
    width: 13px;
    margin-top: 3px;
  }
`;